import { render, staticRenderFns } from "./_chat-area.vue?vue&type=template&id=2b621254&scoped=true"
import script from "./_chat-area.vue?vue&type=script&lang=js"
export * from "./_chat-area.vue?vue&type=script&lang=js"
import style0 from "./_chat-area.vue?vue&type=style&index=0&id=2b621254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b621254",
  null
  
)

export default component.exports